import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { MercadoPipeModule } from '../../mercado/pipes';
import { MercadoTypeaheadModule } from '../../mercado/typeahead';
import { MercadoSituacaoModule } from '../../mercado/situacao';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { UnidadeNegocioMercadoComponent } from './unidade-negocio-mercado.component';
import { UnidadeNegocioMercadoFilterPipe, UnidadeNegocioMercadoSituacaoFilterPipe } from './pipes';
import { UnidadeNegocioMercadoMultiselectComponent } from './multiselect';

@NgModule({
    imports: [
        SharedModule,
        MercadoPipeModule,
        MercadoTypeaheadModule,
        MercadoSituacaoModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        UnidadeNegocioMercadoComponent,
        UnidadeNegocioMercadoMultiselectComponent,
        UnidadeNegocioMercadoFilterPipe,
        UnidadeNegocioMercadoSituacaoFilterPipe
    ],
    exports: [
        UnidadeNegocioMercadoComponent,
        UnidadeNegocioMercadoMultiselectComponent,
        UnidadeNegocioMercadoFilterPipe,
        UnidadeNegocioMercadoSituacaoFilterPipe
    ],
    providers: [
        UnidadeNegocioMercadoFilterPipe,
        UnidadeNegocioMercadoSituacaoFilterPipe
    ]
})
export class UnidadeNegocioMercadoModule { }
